import { Component, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-snackbar',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, TranslateModule],
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss'
})
export class SnackbarComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<SnackbarComponent>,
              public dialog: MatDialog,){
  }

  ngAfterViewInit() {
    if(this.data.closeWithTimer) {
      setTimeout(() => {
        this.closeDialog();
      }, 5000);
    }
  }
  
  closeDialog(){
    this.dialogRef.close();
  }
}

